import { useTranslation } from "react-i18next";

import { useTireResults } from "../../useTireResults";
import {
  approvedBrandGroups,
  getApprovedBrandGroup,
  useApprovedBrand,
  useApprovedManufacturerIds,
} from "./useApprovedBrand";

const labels = {
  approved: "approvedBrands",
  "non-approved": "nonApprovedBrands",
  "star-approved": "starApproved",
} as const;

// Only groups that have tires in the current results, so an empty group (e.g. Approved Brands for a size no Tier 1
// brand makes) is not offered.
export const useApprovedBrandOptions = (): Option[] => {
  const { data: results } = useTireResults();
  const [selectedOptions] = useApprovedBrand();
  const approvedManufacturerIds = useApprovedManufacturerIds();
  const { t } = useTranslation();

  if (!approvedManufacturerIds) {
    return [];
  }

  const presentGroups = new Set(
    (results?.allParts ?? []).map(({ partDetails }) =>
      getApprovedBrandGroup(partDetails.primaryPart, approvedManufacturerIds)
    )
  );

  return approvedBrandGroups
    .filter((group) => presentGroups.has(group))
    .map((group) => ({
      checked: selectedOptions.includes(group),
      label: t(`searchResults.${labels[group]}`),
      value: group,
    }));
};

type Option = {
  checked: boolean;
  label: string;
  value: string;
};
